module.exports = __webpack_public_path__ + "public/StoreIcon/groceryorderOne.svg?6e435461";